import { FeaturedJob } from 'rwl-shared/dist/models';
import {
    ButtonContainer,
    getPageUrl,
    JobMedia,
    mqDown,
    useAnalyticsClickEvent,
} from 'rwl-ui';
import { JobCardDetails } from './JobCardDetails';
import styled from 'styled-components6';
import { serializeMedia } from '../../../utils';
import { forwardRef, useState } from 'react';
import { ClickTargets } from 'rwl-shared/src/models/analytics/UserAction';

export const IMAGE_HEIGHT = 180;
const JobMediaContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: var(--rwl-border-outline);
    border-radius: var(--rwl-radius-sm);
    min-width: 224px;
    max-width: 364px;
    cursor: pointer;
    > * {
        width: 100% !important; // For some reason this sometimes works/sometimes doesn't without !important
    }
    .carousel-image {
        aspect-ratio: unset;
        width: 100%;
        border-radius: 0;
        border-top-left-radius: var(--rwl-radius-sm);
        border-top-right-radius: var(--rwl-radius-sm);
        height: ${IMAGE_HEIGHT}px;
    }
    .placeholder-image {
        height: ${IMAGE_HEIGHT}px;
        object-fit: contain;
    }

    &:hover {
        box-shadow: var(--rwl-shadow-sm);
    }
    transition: box-shadow 0.2s ease-in-out, outline 0.2s ease-in-out;
    ${mqDown('xs')} {
        & > * {
            width: calc(100% + 2 * var(--rwl-spacing-md));
        }
    }
    //if browser has the ability to hover (has a mouse), then show the buttons on hover
    @media (hover: hover) {
        &:hover {
            ${ButtonContainer} {
                visibility: visible;
                opacity: 1;
            }
        }
    }
`;

interface JobCardProps {
    job: FeaturedJob;
    containerStyle?: React.CSSProperties;
    cardStyle?: React.CSSProperties;
    disabledCarousel?: boolean;
    height?: number;
    onClick?: () => void;
}

export const JobCard = forwardRef<HTMLDivElement, JobCardProps>(
    (
        {
            job,
            containerStyle,
            cardStyle,
            disabledCarousel = false,
            onClick = () => void 0,
        },
        ref
    ) => {
        const sendClickEvent = useAnalyticsClickEvent();
        // Used purely for analytics tracking
        const [currentIndex, setCurrentIndex] = useState(0);
        const onChange = (media: any, index: number) => {
            sendClickEvent({
                url: getPageUrl(),
                target:
                    currentIndex < index
                        ? ClickTargets.NEXT
                        : ClickTargets.PREV,
                workSite: job?.id,
                content: media.id,
            });
            setCurrentIndex(index);
        };

        return (
            <JobMediaContainer
                key={`${job.id}_card_details`}
                onClick={onClick}
                style={containerStyle}
                ref={ref}
            >
                <JobMedia
                    media={serializeMedia(job)}
                    staticMapUrl={undefined}
                    style={cardStyle}
                    disabledCarousel={disabledCarousel}
                    onChange={onChange}
                />
                <JobCardDetails job={job} />
            </JobMediaContainer>
        );
    }
);
